import { ILocation } from 'interfaces';
import { axiosPrivate } from 'services/axios';
import { BaseService } from './BaseService';

class PeriodicCostElementService extends BaseService<ILocation> {
  constructor() {
    super('periodic-cost-elements');
  }

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const periodicCostElementService = new PeriodicCostElementService();
